import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  CircularProgress,
  Container,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect } from "react";
import download from "js-file-download";
import Page from "src/components/Page";
import { apiUrl } from "src/Constants";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import ReportSearchFormComponent from "src/components/forms/ReportSearchFormComponent";
import { getBrands } from "src/redux/actions/brand.action";
import { getYearList } from "src/redux/actions/purchaseRequest.action";
import { hasRole } from "src/utils/Auth";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function PRStatusReportComponent() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const {
    result: { companyid, countryid, secureid, perid },
  } = useSelector((state) => state.loginReducer);

  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const brandReducer = useSelector((state) => state.brandReducer);
  const { years } = useSelector((state) => state.purchaseRequestReducer);

  useEffect(() => {
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(getYearList());
    return () => {};
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Page className={classes.root} title="Transaction Tracking">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For purchase requisition status report"
              title="PR Status Report"
            />
          </Card>
        </Box>
        <Box>
          <ReportSearchFormComponent
            formValue={{
              SECID: secureid,
              BUDGET_YEAR: null,
              COUNTRYID: countryid,
              COMPANYID: companyid,
              DATE_FROM: Moment(`11-01-2020`),
              DATE_TO: Moment(),
              BRANDID: "",
              DEPARTID: "",
            }}
            onSubmit={(value) => {
              handleToggle();
              let baseUrl = `${apiUrl}/report/purchase-requisition-status-report`;
              if (hasRole(authorizePR.data, ["manager-report"])) {
                baseUrl += "?userid=" + perid;
              }

              Axios({
                url: baseUrl,
                method: "POST",
                data: value,
                authorization: `Bearer ${localStorage.getItem("token")}`,
                responseType: "blob",
              })
                .then((res) => {
                  handleClose();
                  const filename =
                    "pr-status-report-" +
                    Moment().format("DD-MMM-YYYY_HHmmss") +
                    ".csv";
                  download(res.data, filename);
                })
                .catch((err) => {
                  handleClose();
                  Swal.fire("The system has error.", err.message, "error");
                });
            }}
            year={years.data}
            brand={brandReducer.result}
          />
        </Box>
        <Backdrop
          className={classes.backdrop}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </Page>
  );
}
